import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStep: 1,
  archFolderStructure: null,
  selectedStructure: [],
}

export const architectureConversionSlice = createSlice({
  name: "architectureConversion",
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      console.log("action.reset: ", action.payload)
      state.currentStep = action.payload
    },
    setFolderStructure: (state, action) => {
      state.archFolderStructure = action.payload
      console.log("state.archFolderStructure", state.archFolderStructure)
    },
    setSelectedStructure: (state, action) => {
      state.selectedStructure = action.payload;
      console.log("state.selectedStructure", state.selectedStructure)
    },
  },
})

export const { setCurrentStep, setFolderStructure, setSelectedStructure } = architectureConversionSlice.actions

export default architectureConversionSlice.reducer